export const CPU = 'CPU';
export const PAGINATION_VALUE_25 = 25;
export const PAGINATION_VALUE_50 = 50;
export const PAGINATION_VALUE_100 = 100;
export const PAGINATION_VALUE_200 = 200;
export const PAGINATION_VALUE_500 = 500;



// WEBPACK FOOTER //
// ./src/Constants.js